import { z, ZodRawShape } from 'zod';

import { Id, objectIdSchema } from '../validation/id';
import { docSchema } from './doc.schema';
import { DeepPartial, Sort } from '../types';
import { Pagination } from './pagination.schema';

/** the base model that will be added model in the db */
export const BaseModelSchema = z.object({
  _id: objectIdSchema,
  doc: docSchema,
});

export type BaseModelSchema = z.infer<typeof BaseModelSchema>;
export type QueryOne<T> = DeepPartial<T> & { _id?: Id };
export type PartialData<T> = DeepPartial<T> & { _id?: Id };
/** This is used to give you the correct types when  you want to query a model such as `Order` `Customer`, etc */
export type QueryMany<T> = QueryOne<T> & {
  /**
   * `1` ascending sorting (Smallest to Largest)
   *
   * `-1` descending sorting (Largest to Smallest)
   * */
  _sort?: Sort<T>;
  _pagination?: Pagination;
  /**
   * by default is false
   * skipping pagination will return all docs for a query.
   *
   * Even if you provide `skip` & `limit` ... it will return all docs.
   *
   */
  _skipPagination?: boolean;
  /** Atlas Search. Enable the search on the collection so that if you type something in search it will filter. */
  search?: string;
};

/**
 *
 * @param dataShape a zod data shape
 */
export const createModel = <T extends ZodRawShape>(dataShape: T) => {
  const data = z.object(dataShape);
  const model = BaseModelSchema.extend(data.shape);

  const partial = data.partial();

  return {
    /** the model as it looks in the db */
    model,
    /** the same as the data shape provided but all partial */
    partial,
    /** the provided data shape as a zod schema */
    data,
    /** zod shape for the whole model */
    shape: model.shape,
    /** this schema is designed when creating new entity/doc */
    //newEntity,
  };
};
